import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--services--item"
export default class extends Controller {
  static targets = [
    "mainTemplate",
    "extraTemplate",
    "templateContainer",
  ]

  connect() {
  }

  removeItem(event) {
    document.querySelector(`[id='${event.currentTarget.dataset.templateId}']`).remove()
  }

  addItem(event) {
    this.createFormTemplate(event.currentTarget.dataset.service)
  }

  createFormTemplate(service) {
    let template
    let id = new Date().getTime()

    if (service == "main") {
      template = this.mainTemplateTarget.cloneNode(true)
    } else if (service == "extra") {
      template = this.extraTemplateTarget.cloneNode(true)
    }

    template.innerHTML = template.innerHTML.replaceAll("NEW_RECORD", id)
    template = template.content.firstElementChild
    template.dataset.id = id

    this.templateContainerTarget.appendChild(template)
  }
}
